import { NavBar } from 'antd-mobile';
import './index.scss'
export default function Index(props: any) {
    return <NavBar className='h5NavBar' {...props}>
        <div className='h5Title'>
            {props.children}
        </div>
    </NavBar>
}